import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import roundPrice from '@anm/helpers/pricing/roundPrice';

export const getNextPeriodName = (period: SubscriptionPeriod) =>
  period === 'ANNUAL' ? 'MONTHLY' : 'ANNUAL';

export const getNextInvoiceAmount = (
  period: SubscriptionPeriod,
  annualPrice: number,
  monthlyPrice: number
) => (period === 'ANNUAL' ? annualPrice : monthlyPrice);

export const calcSaveAmount = (annualPrice: number, monthlyPrice: number) =>
  roundPrice(monthlyPrice * 12 - annualPrice);
